import script from "./Press.vue?vue&type=script&lang=ts&setup=true"
export * from "./Press.vue?vue&type=script&lang=ts&setup=true"

import "./Press.vue?vue&type=style&index=0&id=a669b0cc&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a669b0cc"]])

export default __exports__